import { createSlice } from "@reduxjs/toolkit";
import {
  getBarCodeServicesRequests,
  toAddRequestBeneficiaries,
  toGetServices,
  toGetServicesBeneficiaries,
  toGetServicesListRequests,
  toGetServicesRequests,
} from "../actions/services.actions";

const initialState = {
  TotalServices: 0 as number,
  TotalBeneficiaryServices: 0 as number,
  services: [] as any,
  servicesRequests: [] as any,
  servicesBeneficiaries: {
    data: [] as any,
    loading: false,
  },
  servicesListRequest: {
    data: [] as any,
    loading: false,
  },
  barCode: null as any,
  addRequest: {} as any,
  loading: false,
  error: null as unknown | null,
  TotalApplications: 0,
};
export const ServicesSlice = createSlice({
  name: "services",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(toGetServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(toGetServices.fulfilled, (state, action) => {
        state.services = action?.payload?.data;
        state.TotalBeneficiaryServices = action?.payload.total_pages;

        state.loading = false;
      })
      .addCase(toGetServices.rejected, (state, action) => {
        state.TotalBeneficiaryServices = 0 ;
        state.services = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(toGetServicesRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(toGetServicesRequests.fulfilled, (state, action) => {
        state.servicesRequests = action?.payload.data;
        state.TotalServices = action?.payload.total_pages;
        state.loading = false;
      })
      .addCase(toGetServicesRequests.rejected, (state, action) => {
        state.TotalServices = 0;
        state.servicesRequests = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(toGetServicesBeneficiaries.pending, (state) => {
        state.servicesBeneficiaries.loading = true;
      })
      .addCase(toGetServicesBeneficiaries.fulfilled, (state, action) => {
        state.servicesBeneficiaries.data = action?.payload?.data?.result;
        state.servicesBeneficiaries.loading = false;
      })
      .addCase(toGetServicesBeneficiaries.rejected, (state, action) => {
        state.servicesBeneficiaries.data = [];
        state.servicesBeneficiaries.loading = false;
        state.error = action.payload;
      })
      .addCase(toAddRequestBeneficiaries.pending, (state) => {
        state.loading = true;
      })
      .addCase(toAddRequestBeneficiaries.fulfilled, (state, action) => {
        state.addRequest = action?.payload;
        state.loading = false;
      })
      .addCase(toAddRequestBeneficiaries.rejected, (state, action) => {
        state.addRequest = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(toGetServicesListRequests.pending, (state) => {
        state.servicesListRequest.loading = true;
      })
      .addCase(toGetServicesListRequests.fulfilled, (state, action) => {
        state.servicesListRequest.data = action?.payload?.result?.data;
        state.servicesListRequest.loading = false;
        state.TotalApplications = action.payload.total_pages;
      })
      .addCase(toGetServicesListRequests.rejected, (state, action) => {
        state.servicesListRequest.data = [];
        state.servicesListRequest.loading = false;
        state.error = action.payload;
        state.TotalApplications = 0;
      })
      .addCase(getBarCodeServicesRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBarCodeServicesRequests.fulfilled, (state, action) => {
        state.barCode = action?.payload;
        state.loading = false;
      })
      .addCase(getBarCodeServicesRequests.rejected, (state, action) => {
        state.barCode = null;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ServicesSlice.reducer;
